"use strict";
import angular from "angular";

import auth from "./auth";
import notify from "./notify";
import api from "./api";
import common from "./common";
import paperwork from "./paperwork";
import publicWafla from "./wafla";
import communication from "./communication";
import setup from "./setup";
import spray from "./spray";
import kiosk from "./kiosk";
let module = angular.module("app.common", [
    auth.name,
    notify.name,
    api.name,
    common.name,
    paperwork.name,
    publicWafla.name,
    communication.name,
    setup.name,
    spray.name,
    kiosk.name,
]);

export default module;
